import { useEffect, useState } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { Reveal } from "../components/Reveal";
import { api } from "../lib/api";

export default function Faq() {
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    api.get("/faqs").then(({ data }) => setFaqs(data)).catch(() => {});
  }, []);

  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-36 bg-[#FAF9F6]">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <Reveal className="mb-12">
          <p className="overline mb-6">
            <span className="text-[#D7C6A3]">09</span> &nbsp;/&nbsp; Preguntas frecuentes
          </p>
          <h2 className="font-display text-4xl md:text-5xl text-[#2D3732] leading-tight">
            Todo lo que necesitas saber.
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem
                key={f.id}
                value={f.id}
                data-testid={`faq-${i}`}
                className="border-b border-[#E3E0D6]"
              >
                <AccordionTrigger className="text-left font-display text-xl md:text-2xl text-[#2D3732] hover:no-underline py-6 hover:text-[#8A9A6F] transition-colors">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#4A554E] text-base leading-relaxed pb-6 font-light max-w-2xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
